import _classCallCheck from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/inherits.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { addPointerEvent } from '../events/add-pointer-event.mjs';
import { pipe } from '../utils/pipe.mjs';
import { isDragActive } from './drag/utils/lock.mjs';
import { Feature } from '../motion/features/Feature.mjs';
import { frame } from '../frameloop/frame.mjs';
function addHoverEvent(node, isActive) {
  var eventName = isActive ? "pointerenter" : "pointerleave";
  var callbackName = isActive ? "onHoverStart" : "onHoverEnd";
  var handleEvent = function handleEvent(event, info) {
    if (event.pointerType === "touch" || isDragActive()) return;
    var props = node.getProps();
    if (node.animationState && props.whileHover) {
      node.animationState.setActive("whileHover", isActive);
    }
    var callback = props[callbackName];
    if (callback) {
      frame.postRender(function () {
        return callback(event, info);
      });
    }
  };
  return addPointerEvent(node.current, eventName, handleEvent, {
    passive: !node.getProps()[callbackName]
  });
}
var HoverGesture = /*#__PURE__*/function (_Feature) {
  function HoverGesture() {
    _classCallCheck(this, HoverGesture);
    return _callSuper(this, HoverGesture, arguments);
  }
  _inherits(HoverGesture, _Feature);
  return _createClass(HoverGesture, [{
    key: "mount",
    value: function mount() {
      this.unmount = pipe(addHoverEvent(this.node, true), addHoverEvent(this.node, false));
    }
  }, {
    key: "unmount",
    value: function unmount() {}
  }]);
}(Feature);
export { HoverGesture };